module.exports = __webpack_public_path__ + "img/film-03.93eb54ba.svg";